import React from 'react';
import Button from '../../../../../components/control/button/button';
import {
    EButtonSize,
    EButtonType,
} from '../../../../../components/control/button/button.types';
import { useFormikContext } from 'formik';
import { TFilterValues } from '../index';

const ButtonFilterApply: React.FC<{
    onApply?: (values: TFilterValues) => void;
    label?: string;
}> = ({ onApply, label = 'Apply date filters' }) => {
    const form = useFormikContext();

    return (
        <Button
            styleType={EButtonType.Primary}
            size={EButtonSize.Small}
            type={'submit'}
            onClick={async () => {
                await form.submitForm();
            }}
        >
            {label}
        </Button>
    );
};

export default ButtonFilterApply;
